<template>
  <MainLayout>
    <div class="flex justify-center items-center flex-1">
      <div class="flex flex-col gap-y-8">
        <h1 class="text-3xl lg:text-[70px] leading-[74px] font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
          <span class="text-gradient-primary whitespace-nowrap">404</span>
          {{ t('errors.not_found.title') }}
        </h1>

        <div class="flex flex-col gap-y-4">
          <div class="flex flex-col text-center leading-[27px] text-lg font-semibold">
            <p class="text-lighter text-lg">{{ t('errors.not_found.description') }}</p>
          </div>
        </div>

        <div class="flex justify-center items-center">
          <RouterLink :to="{name: 'home.index'}" class="btn btn-lg btn-primary whitespace-nowrap ">
            {{ t('errors.not_found.action') }}
          </RouterLink>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">

import MainLayout from '@/layouts/MainLayout.vue'
import { useI18n } from 'vue-i18n'

const {t} = useI18n()
</script>

<style scoped>

</style>